import "../templateview/templateview.css";
import React, { Fragment } from "react";
import { useState } from "react";
import { Modal } from "reactstrap";
import { useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { CloseButton, Dropdown, NavDropdown, Offcanvas } from "react-bootstrap";
import { saveToLocalStorage } from "utils/LocalStorageUtils";

function Templateview(props) {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobileView, setIsMobileView] = useState(false);
  const navigate = useNavigate();
  const refresh = () => window.location.reload(true)
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };
  const {
    templateViewPage,
    setSelectPage,
    base_url,
  } = props;
  // let element = document.getElementById("meta-test");
  // if (element) {
  //   element.remove()
  // }
  return (
    <Fragment>
      <Modal
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        style={customStyles}
        contentLabel="Example Modal"
        className="img-modaltwo"
      >
        <button
          type="button"
          className="btn btn-light"
          onClick={() => setIsOpen(false)}
        >
          <i className="far fa-times-circle"></i>
        </button>
        <div className="bck-btn">
          <div className="qLnKwP">
            <h1 data-hook="card-title" className="PHJvhr">
              {templateViewPage?.title} - {templateViewPage?.category_name}
            </h1>
          </div>
        </div>

      </Modal>
      <Navbar expand="lg" sticky="top" className="bg-body-tertiary">
        <Container fluid>
          <Navbar.Brand
            href='/'
          >
            <img
              src="./assets/images/logodigital.png"
              width={'150px'}
              height="100"
              className="d-inline-block align-top"
              // className="w-50"
              alt="bnr-img"
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-lg`} style={{marginLeft:'3.5rem'}} />
          <Navbar.Offcanvas
            id={`offcanvasNavbar-expand-lg`}
            aria-labelledby={`offcanvasNavbarLabel-expand-lg`}
            placement="start"
            style={{marginRight:'1.5rem'}}
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title id={`offcanvasNavbarLabel-expand-lg`}>
                <img
                  src="./assets/images/logodigital.png"
                  width={'150px'}
                  height="100"
                  className="d-inline-block align-top"
                  // className="w-50"
                  alt="bnr-img"
                />
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Nav className="me-auto" navbarScroll>
                <div style={{ marginLeft: '20rem' }} />
                <div className="d-flex align-items-center">
                  <Nav.Link className={!isMobileView ? "head-active head-wbicn" : 'head-wbicn'} onClick={() => setIsMobileView(false)}>
                    <i className="fas fa-desktop"></i>
                  </Nav.Link>
                  <span className="dividr-space"> | </span>
                  <Nav.Link
                    className={isMobileView ? "head-active head-wbicn" : "head-wbicn"}
                    onClick={() => setIsMobileView(true)}
                  >
                    <i className="fas fa-mobile-alt"></i>
                  </Nav.Link>
                </div>
              </Nav>
              <div className="jst-tt">
                <span className="head-txt">
                  Click edit and create your own amazing website
                </span>
                <Button onClick={() => { saveToLocalStorage('selectTemplate', templateViewPage); saveToLocalStorage("selectOrderDetail", null); navigate("/templateform"); }} className="get-st-btn">Edit this site</Button>
              </div>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
          <div className="close-button-preview">
            <CloseButton onClick={() => setSelectPage('')} />
          </div>
        </Container>
      </Navbar>
      {!isMobileView ? <div>
        <div className="portimg-crd">
          <iframe
            id="inlineFrameExample"
            width="100%"
            height="100%"
            title="desktop-iframe"
            data-hook="desktop-iframe"
            className="weblayout-iframe"
            src={ templateViewPage?.template_path}
          ></iframe>
        </div>
      </div> :
        <div className="CJ4D6R">
          <div className="aPQdRm">
            <div className="wT06qm">
              <div className="oEUMCt" />
              <div className="aPQdRm KhnDuB">
                <iframe
                  src={
                    base_url +
                    templateViewPage.theme_url
                  }
                  width="100%"
                  height="100%"
                  title="mobile-iframe"
                  data-hook="mobile-iframe"
                />
              </div>
            </div>
          </div>
        </div>}
    </Fragment>
  );
}
export default Templateview;